import PackagePage from '../package-page'
export default PackagePage
